import React, { JSX } from 'react';
import { ApiFlightItem } from '@ibe/api';
import Keys from '../../../_Translations/generated/flight-summary.en.t.json.keys';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';
import SegmentDisplay from './SegmentDisplay';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/flight-summary.en.t.json';
import FlightUtil from '../../../Utils/FlightUtil';

interface FlightInfoItemProps {
  flight: ApiFlightItem;
}

const FlightInfo = (props: FlightInfoItemProps): JSX.Element => {
  const { t } = useTranslation('flight-summary', fallback, Keys);

  const { flight } = props;
  const isRoundTrip = flight.segment.length > 1;
  const firstSegment = flight.segment[0];
  const lastSegment = flight.segment[flight.segment.length - 1];
  return (
    <>
      {isRoundTrip && (
        <strong className="container">
          {`${t(Keys.outbound)} ${t(Keys.flight)}`}:{' '}
          <DateDisplay date={firstSegment.departure} stripTime />
        </strong>
      )}
      {flight.fare && <div className="container">{flight.fare[0].compartment}</div>}
      {flight.fare && flight.fare[0].bookingClass && (
        <div className="container">{flight.fare[0].bookingClass.description}</div>
      )}
      {firstSegment && (
        <div className="container">{FlightUtil.getFlightDuration(firstSegment.flightDuration)}</div>
      )}
      <SegmentDisplay segment={firstSegment} />
      {isRoundTrip && (
        <>
          <hr />
          <strong className="container">
            {`${t(Keys.inbound)} ${t(Keys.flight)}`}:{' '}
            <DateDisplay date={lastSegment.departure} stripTime />
          </strong>

          {flight.fare && <div className="container">{flight.fare[0].compartment}</div>}
          {flight.fare && flight.fare[0].bookingClass && (
            <div className="container">{flight.fare[0].bookingClass.description}</div>
          )}
          {lastSegment && (
            <div className="container">
              {FlightUtil.getFlightDuration(lastSegment.flightDuration)}
            </div>
          )}
          <SegmentDisplay segment={lastSegment} />
        </>
      )}
    </>
  );
};

export default FlightInfo;
